import React, { useContext, useEffect, useRef, useState } from 'react';
import AppContext from '../AppContext';
import { getTranslation } from '../constants/translations';
import { useSwipeable } from 'react-swipeable'; // For swipe gestures
import '../css/home.css';

function Home() {
  const { language } = useContext(AppContext);
  const t = getTranslation(language).home;
  const [activeSlide, setActiveSlide] = useState(0);
  const videoRefs = useRef([]);

  const slides = [
    { type: 'image', src: '/images/logo.webp', alt: 'JR-AI-Consulting logo' },
    { type: 'image', src: '/images/us.webp', alt: 'Ultrasound slide 1' },
    { type: 'image', src: '/images/us2.webp', alt: 'Ultrasound slide 2' },
    {
      type: 'video',
      src: '/images/projects/waver-array-pressure-20260312.mp4',
      poster: '/images/projects/waver-steered-beam-final.webp',
      alt: 'Waver pressure field animation',
    },
    { type: 'image', src: '/images/us4.webp', alt: 'Ultrasound slide 4' },
    { type: 'image', src: '/images/us5.webp', alt: 'Ultrasound slide 5' },
    { type: 'image', src: '/images/us6.webp', alt: 'Ultrasound slide 6' },
    { type: 'image', src: '/images/us7.webp', alt: 'Ultrasound slide 7' },
  ];

  // Change slide automatically every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [slides.length]);

  useEffect(() => {
    videoRefs.current.forEach((video, index) => {
      if (!video) return;

      if (index === activeSlide) {
        video.currentTime = 0;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, [activeSlide]);

  // Handlers for swiping
  const handlers = useSwipeable({
    onSwipedLeft: () =>
      setActiveSlide((prevSlide) => (prevSlide + 1) % slides.length),
    onSwipedRight: () =>
      setActiveSlide((prevSlide) => (prevSlide - 1 + slides.length) % slides.length),
  });

  return (
    <div className="fade-in">
      <section className="hero-shell">
        <div className="hero-copy">
          <div className="hero-kicker">JR-AI-Consulting</div>
          <div className="roles-container">
            <h1 className="roles-text">{t.roles}</h1>
          </div>
          <div className="description">
            {t.description}
          </div>
        </div>

        {/* Carousel */}
        <div className="carousel-container" {...handlers}>
          <div className="image-container">
            {slides.map((slide, index) => (
              <div
                key={slide.src}
                className={`carousel-slide ${
                  activeSlide === index ? 'active' : ''
                }`}
              >
                {slide.type === 'video' ? (
                  <video
                    ref={(node) => {
                      videoRefs.current[index] = node;
                    }}
                    className="carousel-media"
                    muted
                    loop
                    playsInline
                    preload={activeSlide === index ? 'metadata' : 'none'}
                    poster={slide.poster}
                  >
                    <source src={slide.src} type="video/mp4" />
                  </video>
                ) : (
                  <img
                    src={slide.src}
                    alt={slide.alt}
                    className="carousel-media"
                    loading={index === 0 ? 'eager' : 'lazy'}
                    decoding="async"
                    fetchPriority={index === 0 ? 'high' : 'auto'}
                  />
                )}
              </div>
            ))}
          </div>
          <div className="carousel-dots">
            {slides.map((_, index) => (
              <div
                key={index}
                className={`dot ${activeSlide === index ? 'active' : ''}`}
                onClick={() => setActiveSlide(index)}
              ></div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
